import styled from 'styled-components/macro'

export const StyledVideo = styled.video<{ isFullscreen: boolean }>`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;

  &::-webkit-media-controls {
    display: ${(props) => (props.isFullscreen ? 'none' : 'block')};
  }

  &::-webkit-media-controls-enclosure {
    display: ${(props) => (props.isFullscreen ? 'none' : 'block')};
  }
`
